"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.update_single_element = void 0;
const store_1 = require("../../../store");
const api_1 = require("../../api");
function update_single_element(request, loader = true) {
    var _a;
    return __awaiter(this, void 0, void 0, function* () {
        const { userState } = store_1.redux_store.getState();
        const { token } = userState;
        // Choose endpoint based on document status
        // DRAFT documents use the draft endpoint (owner only)
        // Published documents (SENT, VIEWED, SIGNING, etc) use the published endpoint
        const isDraft = request.documentStatus === "DRAFT";
        const endpoint = isDraft ? "draft/update-single-element" : "update-single-document-element";
        // Remove documentStatus from request body (only used for endpoint selection)
        const { documentStatus } = request, requestBody = __rest(request, ["documentStatus"]);
        // Simplified authentication: JWT token sufficient for all operations (PR #40)
        return yield new api_1.API().apiPut({
            baseUrl: (_a = process.env.API_URL) !== null && _a !== void 0 ? _a : "",
            endpoint: endpoint,
            content: requestBody,
            loader: loader,
            authorization: `${token}`,
        });
    });
}
exports.update_single_element = update_single_element;
